export default "__VITE_ASSET__Dn65djMl__"